module.exports = __webpack_public_path__ + "static/img/settings.dd87ea6e.svg";